import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { I18nService } from '../../service/i18n.service';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-rodape',
  standalone: true,
  imports: [TranslateModule, DialogModule],
  templateUrl: './rodape.component.html',
  styleUrl: './rodape.component.scss'
})
export class RodapeComponent {
  translate = inject(TranslateService);
  i18nService = inject(I18nService);

  visibleDialogPolitica: boolean = false;
  visibleDialogTermo: boolean = false;

  constructor() {
    this.translate.use(this.i18nService.idioma.value.code);
  }

  showDialogPolitica() {
    this.visibleDialogPolitica = true;
}
  showDialogTermo() {
    this.visibleDialogTermo = true;
}
}
